import React from "react";
import { Box, Container, Grid, Paper, Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
//import { AccordionComponent, AccordionComponentProps } from "../components/AccordionComponent";
//import { CustomerCaseDataRepresentationComponent, CustomerCaseDataRepresentationVariant } from "../components/datapresentation/CustomerCaseDataRepresentation";
import { ListSkillsDataComponent, ListSkillsRepresentationVariant } from "../components/datapresentation/SkillsDataComponent";
import { BorderBottom } from "@mui/icons-material";
import { ImageComponent } from "../components/ImageComponent";
import { DynamicContentComponent, DynamicContentItem } from "../components/DynamicContentComponent";
import { getPath, Paths } from "../utils/paths";
import { BreadcrumbComponent, BreadCrumProps } from "../components/BreadcrumComponent";

type SkillProps = {
  title: String;
  categoryKey: String;
  description: String;
  image?: String;
}

type SkillCategoryProps = {
  title: String;
  key: String;
  priority: Number;
  image?: String;
  skills: SkillProps[];
}


export const Skills = () => {
  const { t, ready } = useTranslation("skills");
  const [skillCategories, setSkillCategories] = React.useState<SkillCategoryProps[]>([]);
  const [skills, setSkills] = React.useState<SkillProps[]>([]);
  if (!ready) return "loading translations...";

  const breadCrums = t("breadcrums", { returnObjects: true }) as BreadCrumProps[];
  
  const topDynamicContent = t("topContent", { returnObjects: true }) as DynamicContentItem[];
  
  const skillCategoriesTranslations = t("skillCategories", { returnObjects: true }) as SkillCategoryProps[];
  const skillsTranslations = t("skills", { returnObjects: true }) as SkillProps[];

  // Create and load list of competences and categories on mount
  React.useEffect(() => {
    if (ready) {
      const skillCategoriesList = skillCategoriesTranslations.map((item) => ({
        title: item.title,
        key: item.key,
        priority: item.priority,
        image: item.image,
        skills: new Array(),
      }));

      const skillsList = skillsTranslations.map((item) => ({
        title: item.title,
        categoryKey: item.categoryKey,
        description: item.description,
        image: item.image,
      }));
      setSkills(skillsList);
      // Add skills to categories
      skillsList.forEach(skill => {
        const matchingCategory = skillCategoriesList.find(c => c.key == skill.categoryKey);
        if (!matchingCategory) {
          console.log("No skill category found for category: " + skill.categoryKey);
        } else {
          matchingCategory.skills.push(skill);
        }

      });  
      setSkillCategories(skillCategoriesList);

    }
  }, [ready]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    //maxHeight: '400px',
    overflowY: 'auto',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
    '&': {
    //'& .MuiTypography-body1 *': {
      //BorderBottom: 0,
      //background: "linear-gradient(to right, #F83901, #FCE26F)"
      padding: "0",
      color: "#FFFFFF",
      marginTop: "16px"
      //"margin-top": "16px" 
    },
  }));

  // stack the categories according to priority in 4 columns
  const numColumns = 4;
  const sortedCategories = skillCategories.sort((a, b) => Number(a.priority) - Number(b.priority));
  //const sortedCategories = skillCategories.sort((a, b) => Number(a.skills.length) - Number(b.skills.length)).reverse();
  // create multi arrya for stack
  const stacks = new Array();
  for (let i = 0; i < numColumns; i++) {
    stacks[i] = new Array()  
  }
  sortedCategories.forEach((cat, index) => {
      stacks[index%numColumns].push(cat);
  });  

  return (
     <>
      <ImageComponent
        imageSrc={`${getPath(Paths.IMAGES_MISC, false)}/rubrics-cubes.jpg`}
        imageProps={{
          width: "100%",
          height: "auto"
        }}
      />
      <BreadcrumbComponent breadcrums={breadCrums} />
      <Box>
        <DynamicContentComponent
          items={topDynamicContent}
          key={"skills-top-content"}
        />
      </Box>

      <Grid container spacing={2} sx={{ marginTop: "16px" }}>
        {stacks.map((stack, index) => {
          return (
            <Grid size={12/numColumns} key={`skills-grid-stack-${index}`}>
              <Stack spacing={2}>
                {stack.map((category, index2) => {
                  return (
                    <Item key={`skills-grid-item-${index2}`}>
                      <ListSkillsDataComponent
                        skills={category.skills}
                        categoryTitle={category.title}
                        variant={ListSkillsRepresentationVariant.VARIANT1}
                      />
                    </Item>
                )})}
              </Stack> 
            </Grid>    
          )
        })}
      </Grid>
    </>
  )
}